import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { FormikProps } from 'formik';
import { ListItemText, Menu as MuiMenu, MenuItem } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { ClientGroupSource, ContentApproval } from 'api';
import { ValidatedCheckbox } from 'components';

interface IProps extends WithStyles<typeof styles> {
  formikProps: FormikProps<ClientGroupSource>;
  anchorEl: HTMLElement;
  onApproveChange: (type: ContentApproval) => void;
  onClose: () => void;
}

const styles = ({ spacing, typography }: Theme) =>
  createStyles({
    label: {
      margin: 0,
    },
    menuPadding: {
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
    },
    menuItem: {
      paddingTop: 11,
      paddingBottom: 11,
      fontSize: typography.pxToRem(16),
      '&:hover': {
        backgroundColor: 'transparent',
        color: 'inherit',
      },
      '&$menuItemSelected': {
        backgroundColor: 'transparent',
        color: 'inherit',
        fontWeight: 400,
        '&:hover': {
          backgroundColor: 'transparent',
          fontWeight: 400,
        },
      },
    },
    menuItemSelected: {},
    menuItemText: {
      marginRight: spacing(8),
    },
  });

class Menu extends Component<IProps> {
  handleCheckedValue = (value: ContentApproval) => {
    return value === ContentApproval.Autoapproved;
  };

  handleApproveChange = () => {
    const { formikProps, onApproveChange } = this.props;
    const { setFieldValue, values } = formikProps;
    const { approval } = values;

    const isNullOrReview = !approval || approval === ContentApproval.Submitted;
    const approvalType = isNullOrReview ? ContentApproval.Autoapproved : ContentApproval.Submitted;

    setFieldValue('approval', approvalType);

    if (values.id) {
      onApproveChange(approvalType);
    }
  };

  render() {
    const { anchorEl, classes, onClose } = this.props;
    const menuClasses = { padding: classes.menuPadding };
    const itemClasses = { root: classes.menuItem, selected: classes.menuItemSelected };

    return (
      <MuiMenu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={onClose}
        MenuListProps={{ classes: menuClasses }}>
        <MenuItem classes={itemClasses} onClick={this.handleApproveChange}>
          <ListItemText
            className={classes.menuItemText}
            primaryTypographyProps={{ variant: 'inherit' }}
            primary={<Trans i18nKey="groups:autoApprove" />}
          />
          <ValidatedCheckbox
            name="approval"
            labelClasses={{ root: classes.label }}
            checkedFn={this.handleCheckedValue}
          />
        </MenuItem>
      </MuiMenu>
    );
  }
}

export default withStyles(styles)(Menu);
